module.exports = __webpack_public_path__ + "static/media/favicon-slr.a6e05fe0.svg";